import moment from 'moment';
import { isEmptyArray } from '../../../../../../core/util/array';
import { ORDERED_WEEK_DAYS } from '../../../../../../constants';
import { hasKnownHours } from '../../../../../../core/util/location';
import { isMidnightish } from '../../../../../../core/util/time';
import { isEmpty } from '../../../../../../core/util/empty';
import { safeGet } from '../../../../../../core/util/object';

const CLOSED = 'Closed';
const UNKNOWN_HOURS = 'Unknown';
const DEFAULT_CONTENT = '';

const TIME_INPUT_FORMAT = 'HH:mm:ss';
const TIME_OUTPUT_FORMAT_USER = 'h:mm a';
const TIME_OUTPUT_FORMAT_SEO = 'HH:mm';

const formatTimeUser = time => moment(time, TIME_INPUT_FORMAT).format(TIME_OUTPUT_FORMAT_USER);
const formatTimeSEO = time => moment(time, TIME_INPUT_FORMAT).format(TIME_OUTPUT_FORMAT_SEO);

const getDisplayHours = (from, to) => `${formatTimeUser(from)} - ${formatTimeUser(to)}`;
const getContent = (day, from, to) =>
  `${day.substring(0, 2)} ${formatTimeSEO(from)}-${formatTimeSEO(to)}`;

const safeMidnight = time => (isMidnightish(time) ? '00:00:00' : time);

const getEffectiveDate = (hoursSpecial, day, timeZone) => {
  const specialHours = hoursSpecial.filter(specialHours => {
    const hasSameNameOfDay = moment(specialHours.effective_date).format('dddd') === day;
    const isNotInThePast = moment(specialHours.effective_date).isSameOrAfter(
      moment()
        .tz(timeZone)
        .startOf('day')
    );
    const isWithinNextWeek = moment(specialHours.effective_date).isBefore(
      moment()
        .tz(timeZone)
        .startOf('day')
        .add('1', 'w')
    );
    return hasSameNameOfDay && isNotInThePast && isWithinNextWeek;
  });

  const effectiveDate = safeGet(specialHours)('0.effective_date');
  return effectiveDate && moment(effectiveDate);
};

const genHours = (hours, hoursDefault, hoursSpecial, timeZone) =>
  !hasKnownHours(hours)
    ? ORDERED_WEEK_DAYS.map(day => ({
        day,
        content: DEFAULT_CONTENT,
        hours: UNKNOWN_HOURS,
        isSpecialHour: false,
      }))
    : ORDERED_WEEK_DAYS.map(day => {
        const hoursData = { day };
        if (!isEmptyArray(hours[day])) {
          const fromTime = hours[day][0].fromTime;
          const toTime = hours[day][hours[day].length - 1].toTime;

          hoursData.hours = getDisplayHours(safeMidnight(fromTime), safeMidnight(toTime));
          hoursData.content = getContent(day, fromTime, toTime);
          hoursData.isSpecialHour = hours[day][0].isSpecial;
          if (hoursData.isSpecialHour)
            hoursData.effectiveDate = getEffectiveDate(hoursSpecial, day, timeZone);
        } else {
          hoursData.hours = CLOSED;
          hoursData.content = DEFAULT_CONTENT;
          // if the clinic is not closed in default hours, then it's a special hour treatment
          hoursData.isSpecialHour = !isEmpty(hoursDefault[day]);

          if (hoursData.isSpecialHour)
            hoursData.effectiveDate = getEffectiveDate(hoursSpecial, day, timeZone);
        }

        return hoursData;
      });

export { genHours };
